// ============================================================================
// GL REPLACEMENT TRANSACTION ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/gl-replacements';

export const glReplacementEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  submit: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/submit`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  checkPending: (mappingId: string) => `${buildEndpoint(BASE_PATH)}/check-pending?mappingId=${mappingId}`,
} as const;

export default glReplacementEndpoints;
